/**
 * Safe integer for API payloads (never NaN).
 */
export function safeParseInt(val) {
  if (val === null || val === undefined || val === "") return 0;
  const n = parseInt(val, 10);
  return Number.isNaN(n) ? 0 : n;
}
